import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import logo from "../../logo.jpg";
import GetProfile from "../../Api/Speakers/Profile/GetProfile";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { Dropdown, Image } from "react-bootstrap";

const Header = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const currentLanguage = i18n.language === "ar" ? "العربية" : "English";
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const location = useLocation();

  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const [userRole, setUserRole] = useState(null);
  const [userName, setUserName] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [profile, setProfile] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleLogin = () => {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);

      if (token) {
        GetProfile.get()
          .then((response) => {
            setUserRole(response.userRole);
            setProfile(response);
            setUserName(
              i18n.language === "ar"
                ? response.arabicFullName
                : response.englishFullName
            );
            setProfileImage(response.profileImage || "");
          })
          .catch((error) => {
            console.error("خطأ في جلب بيانات المستخدم:", error);
          });
      }
    };

    handleLogin();

    window.addEventListener("user-logged-in", handleLogin);

    return () => {
      window.removeEventListener("user-logged-in", handleLogin);
    };
  }, []);

  useEffect(() => {
    if (profile) {
      setUserName(
        i18n.language === "ar"
          ? profile.arabicFullName
          : profile.englishFullName
      );
    }
  }, [i18n.language, profile]);

  const handleLanguageChange = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    localStorage.setItem("i18nextLng", newLang);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    navigate("/admin-login");
  };

  // دالة لتبديل حالة القائمة المنسدلة
  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState);
  };

  useEffect(() => {
    // عند تغيّر المسار، أغلق القائمة
    setIsNavbarOpen(false);
  }, [location]);

  useEffect(() => {
    const closeNavbar = () => {
      setIsNavbarOpen(false);
    };

    // أغلق القائمة عند التنقل بين الصفحات
    window.addEventListener("popstate", closeNavbar);

    return () => {
      window.removeEventListener("popstate", closeNavbar);
    };
  }, []);

  return (
    <header className="dashboard-header shadow" dir={languageDirection}>
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top container-fluid h-100">
        <div className="container ">
          {/* يسار القائمة: الشعار وزر السايدبار */}
          <Link className="navbar-brand fw-bold text-primary-custom" to="/">
            <img
              src={logo}
              alt={t("footer_logo_alt")}
              style={{ maxHeight: "50px", width: "auto" }}
              className="img-fluid"
            />
            <span className="ms-2 fs-5 fw-bold d-none d-md-inline-block">
              {t("dashboard")}
            </span>
          </Link>

          {/* زر إظهار/إخفاء القائمة في الجوال */}
          <button
            className={`navbar-toggler ${isNavbarOpen ? "" : "collapsed"}`}
            type="button"
            onClick={() => setIsNavbarOpen((prev) => !prev)}
            aria-controls="navbarNav"
            aria-expanded={isNavbarOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* عناصر القائمة اليمنى */}
          <div
            className={`collapse navbar-collapse justify-content-end ${
              isNavbarOpen ? "show" : ""
            }`}
            id="navbarAdmin"
          >
            <ul className="navbar-nav align-items-center gap-2">
              {/* مبدل اللغة */}
              <li className="nav-item">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={handleLanguageChange}
                >
                  <i className="fas fa-globe me-1"></i>
                  {i18n.language === "ar" ? "EN" : "AR"}
                </button>
              </li>


              {/* الإشعارات */}
              {/* <Dropdown align="end" className="nav-item">
                <Dropdown.Toggle
                  variant="outline-secondary"
                  className="position-relative"
                  id="notification-dropdown"
                >
                  <i className="fas fa-bell"></i>
                  <span className="position-absolute top-0 end-0 translate-middle badge rounded-pill bg-danger">
                    3
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="notifications-dropdown">
                  <h6 className="dropdown-header">{t("notifications")} (3)</h6>
                  <Dropdown.Item
                    as="div"
                    className="d-flex align-items-center py-2"
                  >
                    <div className="notification-icon bg-primary-custom text-white">
                      <i className="fas fa-user-plus"></i>
                    </div>
                    <div className="ms-3">
                      <div className="notification-title fw-medium">
                        {t("new_user")}
                      </div>
                      <p className="notification-text text-muted mb-0 small">
                        {t("new_speaker_registered")}
                      </p>
                      <span className="notification-time text-muted smaller">
                        {t("minutes_ago")}
                      </span>
                    </div>
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item className="text-center py-2" href="#">
                    {t("view_all_notifications")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}


              {/*  قائمة المستخدم */}
              <Dropdown align="end" className="nav-item" ref={dropdownRef} dir={languageDirection}>
                <Dropdown.Toggle
                  variant="light"
                  className="d-flex align-items-center border-0"
                  id="user-dropdown"
                >
                  {profileImage && (
                    <Image
                      src={profileImage}
                      alt="User"
                      roundedCircle
                      width="30"
                      height="30"
                      className="me-2"
                    />
                  )}
                  {userName && <span>{userName}</span>}
                </Dropdown.Toggle>

                <Dropdown.Menu className={dropdownOpen ? "show" : ""}>
                  <Dropdown.Item href="#">
                    <i className="fas fa-user me-2"></i> {t("profile")}
                  </Dropdown.Item>
                  <Dropdown.Item href="#">
                    <i className="fas fa-cog me-2"></i> {t("settings")}
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item href="/">
                    <i className="fas fa-external-link-alt me-2"></i>{" "}
                    {t("main_site")}
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleLogout} className="text-danger">
                    <i className="fas fa-sign-out-alt me-2"></i> {t("logout")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
